import axios from "axios";
import URL from "../../helpers/URL";
import configuration from "./configuration";

export const createBudget = (data:any) => {
    const config = configuration()
    return axios.post(URL.createBudget, data, config)
}

export const getBudgets = () => {
    const config = configuration()
    return axios.get(URL.getBudgets, config)
}